import { useApi } from './use-api-call';

export const useSearchCountryApi = () =>
    useApi<{
        countries: CountryDTO[];
        allowEdit: boolean;
    }>('/country/search-country');

export const useGetCountryApi = () =>
    useApi<{ country: CountryDTO; allowEdit: boolean }>('/country/get-country/{id}');

export const useSaveCountryApi = () => useApi<{ country: CountryDTO }>('/country/save-country');

export const useDeleteCountryApi = () => useApi('/country/delete-country/{id}');

export interface CountryDTO {
    id: string;
    name: string;
}
